import React from 'react';
import {
	Box,
	Card,
	CardContent,
	makeStyles,
	Typography,
} from '@material-ui/core';
import moment from 'moment';
import DetailItem from '../components/detailItem';
import clsx from 'clsx';
import Label from 'src/components/Label';

const useStyle = makeStyles(theme => ({
	root: {
		'& .MuiCardContent-root:last-child': {
			paddingBottom: `${theme.spacing(1)}px !important`,
		},
	},
	lastChild: {
		borderBottom: 0
	},
	customItem: {
		borderBottom: `1px solid ${theme.palette.divider}`,
	},
	fontWeightMedium: {
		fontWeight: theme.typography.fontWeightMedium
	}
}));

function Details({ entity, contractLine, className }) {
	const classes = useStyle();
	const contractExpire = entity?.contract?.contractEndDate || null;
	const contract = contractLine?.contract;

	return (
		<Card className={clsx(classes.root, className)}>
			<CardContent>
				<DetailItem title="Cliente" value={entity?.contract?.customer?.name} />
				<DetailItem
					title="Tipo Fornitura"
					value={entity?.podPdr.counterElement === 'POD' ? 'Luce' : 'Gas'}
				/>
				<DetailItem
					title={`N° ${entity?.podPdr.counterElement}`}
					value={entity?.podPdr.code}
				/>
				<DetailItem title="N° Contratto" value={contract?.no} />
				<DetailItem
					title="Data attivazione"
					value={moment(entity?.contractDate).format('DD MMMM YYYY')}
				/>
				{contractExpire && (
					<DetailItem
						title="Data Scadenza"
						value={moment(contractExpire).format('DD MMMM YYYY')}
					/>
				)}
				<DetailItem
					title="Data stipula"
					value={moment(contract?.contractDate).format('DD MMMM YYYY')}
				/>
				<DetailItem
					title="Data Inizio"
					value={moment(contract?.contractBeginDate).format('DD MMMM YYYY')}
				/>

				{contract?.contractEndDateNullable && (
					<DetailItem
						title="Data Fine"
						value={moment(contract?.contractEndDateNullable).format(
							'DD MMMM YYYY'
						)}
					/>
				)}
				<Box
					display="flex"
					justifyContent="space-between"
					px={2}
					pb={1}
					mb={1}
					className={classes.customItem}
				>
					<Typography
						variant="body2"
						color="primary"
						className={classes.fontWeightMedium}
					>
						Stato
					</Typography>

					<Label color={contract?.active ? 'success' : 'error'}>
						{contract?.active ? 'attivo' : 'cessato'}
					</Label>
				</Box>
				<DetailItem
					title="Metodo di Pagamento"
					value={contract?.paymentMethod?.name}
				/>
				<DetailItem
					title="Fatturazione"
					value={contract?.invoiceCadence?.name}
				/>
				<DetailItem
					title="Sede Legale"
					value={contractLine?.supplyLocation?.fullAddress}
					className={
						(!contractLine?.invoiceLocation?.fullAddress ||
							!contractLine?.contract?.customer.deliveryPlaceAddressAsGoogle) &&
						classes.lastChild
					}
				/>

				{(contractLine?.invoiceLocation?.fullAddress ||
					contractLine?.contract?.customer.deliveryPlaceAddressAsGoogle) && (
					<DetailItem
						title="Sede Spedizione"
						value={
							contractLine?.invoiceLocation?.fullAddress ||
							contractLine?.contract?.customer.deliveryPlaceAddressAsGoogle
						}
						className={classes.lastChild}
					/>
				)}
			</CardContent>
		</Card>
	);
}

export default Details;
